import { ChatMessage, DeepLink, SenderRole } from "@b2bportal/chat-api";
import clsx from "clsx";
import Markdown from "react-markdown";

import { ChatAvatar } from "../ChatAvatar";
import { ChatMessageMetadata } from "../ChatMessageMetadata";
import { DeepLinkMessage } from "../DeepLinkMessage";

import styles from "./ChatMessage.module.scss";
import { AnchorHTMLAttributes } from "react";

export interface IChatMessageComponentProps {
  message: ChatMessage;
  showMetadata?: boolean;
  handleDeepLink: (deepLink: DeepLink) => void;
}

const ChatMessageComponent = (props: IChatMessageComponentProps) => {
  if (props.message.senderRole === SenderRole.Agent) {
    return AgentChatMessage(props);
  } else {
    return UserChatMessage(props);
  }
};

const AgentChatMessage = (props: IChatMessageComponentProps) => {
  const { message, showMetadata = false } = props;

  const LinkFormatter = ({
    href,
    children,
  }: AnchorHTMLAttributes<HTMLAnchorElement>) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );

  return (
    <div className={clsx(styles.messageContainer, styles.agent)}>
      <ChatAvatar className={styles.messageAvatar} />
      <div className={styles.messageContent}>
        <Markdown
          className={clsx(styles.message, styles.messageAgent)}
          components={{
            a: LinkFormatter,
          }}
        >
          {message.content}
        </Markdown>
        {props.message.deepLink && (
          <DeepLinkMessage
            deepLink={props.message.deepLink}
            handleDeepLink={props.handleDeepLink}
          />
        )}
      </div>
      {showMetadata && (
        <ChatMessageMetadata
          agent
          className={styles.messageMetadata}
          timestamp={message.timestamp}
        />
      )}
    </div>
  );
};

const UserChatMessage = (props: IChatMessageComponentProps) => {
  const { message, showMetadata = false } = props;
  const { content, status, timestamp } = message;
  const statusLC = status.toLowerCase();

  return (
    <div className={clsx(styles.messageContainer, styles.user)}>
      <div className={styles.messageContent}>
        <div
          className={clsx(styles.message, styles.messageUser, styles[statusLC])}
        >
          {content}
        </div>
      </div>
      {showMetadata && (
        <ChatMessageMetadata
          className={styles.messageMetadata}
          status={status}
          timestamp={timestamp}
        />
      )}
    </div>
  );
};

export default ChatMessageComponent;
